import React, {useContext, useEffect} from 'react';
import fotoPerfil from './images/foto-perfil.png';
import './Perfil.css';
import Header from './components/Header';
import PortfolioContext from './context/PortfolioContext';
import Footer from './components/Footer';
import { SiJavascript,SiReact,SiCss3,SiRedux,SiMysql,SiDocker } from 'react-icons/si';


function Perfil() {
  const { darkTheme,setDarkTheme } = useContext(PortfolioContext);

  useEffect(()=>{
    const exists = localStorage.getItem('theme');
    if (exists) {
      const json = JSON.parse(exists);
      console.log(json);
      setDarkTheme(json)
    }
  },[setDarkTheme])
  
  return (
    <div className={darkTheme ? "all-perfil-dark" : "all-perfil"}>
      <Header/>
      <div>
        <div className={darkTheme? "perfil-dark":"perfil"}>
          <div className="fundo">
            <div className={darkTheme? "foto-e-nome-dark": "foto-e-nome"}>
              <img src={fotoPerfil} className="fotoPerfil" alt="foto de vitor" />
              <p className="nome">Vitor Oliveira Silva</p>
            </div>
          </div>
          <div className={darkTheme? "sobre-dark": "sobre"}>
            <h1 className="titulo-sobre">Sobre</h1>
            <p className="sobre-texto">Formado em Análise e Desenvolvimento de Sistemas na UNA, atualmente estudo Desenvolvimento Web na Trybe.  </p>
            <p className="sobre-texto">Mineiro , situado na cidade de Betim-MG, em busca de uma vaga de Dev Junior , realizei o primeiro contato com a area de TI através dos games.</p>
          </div>
        </div>
        <div />
      </div>
      
      <div className={darkTheme?"hard-skills-dark":"hard-skills"}>
        <h1 className="hard-skills-title">Hard Skills</h1>
        <div className="container-hardSkills">
          <div className="container-img">
            <div className={darkTheme ? "icons-hard-skills-dark" : "img-hard-skills"}>< SiJavascript size={60}/></div>
            <h5>Java Script</h5>
            <div className="traco"></div>
          </div>
          <div className="container-img">
            <div className={darkTheme ? "icons-hard-skills-dark" : "img-hard-skills"}>< SiReact size={60}/></div>
            <h5>React</h5>
            <div className="traco"></div>
          </div>
          <div className="container-img">
            <div className={darkTheme ? "icons-hard-skills-dark" : "img-hard-skills"}><SiCss3 size={60}/></div>
            <h5>CSS</h5>
            <div className="traco"></div>
          </div>
          <div className="container-img">
            <div className={darkTheme ? "icons-hard-skills-dark" : "img-hard-skills"}><SiRedux size={60}/></div>
            <h5>Redux e Context</h5>
            <div className="traco"></div>
          </div>
          <div className="container-img">
            <div className={darkTheme ? "icons-hard-skills-dark" : "img-hard-skills"}><SiMysql size={60}/></div>
            <h5>Mysql</h5>
            <div className="traco"></div>
          </div>
          <div className="container-img">
          <div className={darkTheme ? "icons-hard-skills-dark" : "img-hard-skills"}><SiDocker size={60}/></div>
            <h5>Docker</h5>
            <div className="traco"></div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
      <br/>
      <Footer />
    </div>
  );
};

export default Perfil;
